/* MT | Movimiento de la tienda: aparición al hacer scroll, inclinación 3D al pasar
   el ratón, paralaje (ratón en ordenador, scroll en móvil), ondas al tocar los
   botones y lluvia de fruta. Se activa solo sobre lo que lleva data-bt-*. */
(function () {
  if (window.__btInit) return;
  window.__btInit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- aparición al hacer scroll ---- */
  var io = ('IntersectionObserver' in window && !reduce)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
    : null;
  function scanReveal(root) {
    (root || document).querySelectorAll('[data-bt-reveal]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---- inclinación 3D (solo ratón) ---- */
  function bindTilt(root) {
    if (!finePointer || reduce) return;
    (root || document).querySelectorAll('[data-bt-tilt]:not([data-bt-tilt-on])').forEach(function (el) {
      el.setAttribute('data-bt-tilt-on', '');
      var max = parseFloat(el.getAttribute('data-bt-tilt')) || 8;
      var raf;
      el.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.transform = 'perspective(900px) rotateX(' + (-y * max) + 'deg) rotateY(' + (x * max) + 'deg) translateY(-6px)';
          el.style.setProperty('--mx', (x + 0.5) * 100 + '%');
          el.style.setProperty('--my', (y + 0.5) * 100 + '%');
        });
      });
      el.addEventListener('mouseleave', function () { cancelAnimationFrame(raf); el.style.transform = ''; });
    });
  }

  /* ---- paralaje: ratón en ordenador, scroll en móvil ---- */
  var px = [];
  function scanParallax(root) {
    (root || document).querySelectorAll('[data-bt-px]:not([data-bt-px-on])').forEach(function (el) {
      el.setAttribute('data-bt-px-on', '');
      px.push(el);
    });
  }
  if (!reduce) {
    var mx = 0, my = 0, ticking = false;
    function paint() {
      ticking = false;
      var vh = window.innerHeight;
      px.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-bt-px')) || 0.2;
        var tx = 0, ty = 0;
        if (finePointer) { tx = mx * 40 * k; ty = my * 40 * k; }
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) ty += ((r.top + r.height / 2) - vh / 2) * -k * 0.35;
        el.style.translate = tx.toFixed(1) + 'px ' + ty.toFixed(1) + 'px';
      });
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }
    window.addEventListener('scroll', req, { passive: true });
    if (finePointer) window.addEventListener('mousemove', function (e) {
      mx = e.clientX / window.innerWidth - 0.5; my = e.clientY / window.innerHeight - 0.5; req();
    }, { passive: true });
    window.addEventListener('load', req);
  }

  /* ---- onda al tocar botones ---- */
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('.bt-btn, [data-bt-ripple]');
    if (!b || reduce) return;
    var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height);
    var dot = document.createElement('span');
    dot.className = 'bt-ripple';
    dot.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (e.clientX - r.left - s / 2) + 'px;top:' + (e.clientY - r.top - s / 2) + 'px';
    b.appendChild(dot);
    setTimeout(function () { dot.remove(); }, 650);
  });

  /* ---- lluvia de fruta ---- */
  window.btBurst = function (x, y, list, n) {
    if (reduce) return;
    list = (list && list.length) ? list : ['🍓', '🍊', '🥝', '🍋', '🍑', '🫐'];
    n = n || 14;
    for (var i = 0; i < n; i++) {
      (function (i) {
        var s = document.createElement('span');
        s.className = 'bt-burst';
        s.textContent = list[i % list.length];
        s.style.left = x + 'px'; s.style.top = y + 'px';
        document.body.appendChild(s);
        var ang = Math.random() * Math.PI * 2, dist = 70 + Math.random() * 120;
        var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 60;
        var rot = (Math.random() - 0.5) * 540;
        s.animate([
          { transform: 'translate(-50%,-50%) scale(.3)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(1.2) rotate(' + rot / 2 + 'deg)', opacity: 1, offset: 0.55 },
          { transform: 'translate(calc(-50% + ' + dx * 1.2 + 'px), calc(-50% + ' + (dy + 160) + 'px)) scale(.8) rotate(' + rot + 'deg)', opacity: 0 }
        ], { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.4,1)' }).onfinish = function () { s.remove(); };
      })(i);
    }
  };

  /* ---- añadir al carrito compartido (portada, barra fija, CTA) ---- */
  window.btAddToCart = function (variantId, qty, btn, onDone) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (x) { return x.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = '<span>Añadiendo…</span>'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || !state.items) throw new Error(state.description || state.message || '');
        if (btn) {
          var r = btn.getBoundingClientRect();
          window.btBurst(r.left + r.width / 2, r.top + r.height / 2);
        }
        if (cart && state.sections && typeof cart.renderContents === 'function') {
          state.key = state.items[0].key;
          cart.renderContents(state);
        } else {
          window.location.href = '/cart';
        }
        if (onDone) onDone(null);
      })
      .catch(function (err) { if (onDone) onDone(err.message || 'No se ha podido añadir. Inténtalo de nuevo.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  };

  function scanAll(root) { scanReveal(root); bindTilt(root); scanParallax(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scanAll(); });
  else scanAll();
  /* editor de Shopify: al añadir/editar una sección */
  document.addEventListener('shopify:section:load', function (e) { scanAll(e.target); });
  window.btScan = scanAll;
})();
